import { EMPTY, of } from 'rxjs';
import { defaultIfEmpty, filter, map, mergeMap, take } from 'rxjs/operators';

import { getGeneralInfoContent } from 'actions/other';
import { getOffers } from 'actions/user';
import routes from 'constants/routes';

import { getSettings } from '../actions/settings';
import { connectPublicSocket, connectSocket } from '../actions/socket';
import {
  getAssetList,
  getProductList,
  getSpotIndices,
  // getSparklineData,
  // initiateTicker,
  // initiateTicker,
  getStats,
  getAllTickers,
  getOptionsInfo,
} from '../actions/trade';
import { isNotEmpty } from '../ramdax';

export const initialBoot = (action$, state$) =>
  EMPTY.pipe(
    defaultIfEmpty('Initial Boot'),
    mergeMap(() => {
      const pathname = state$.value?.router?.location?.pathname || '';
      const isDegradedMode = pathname.includes(routes.degradedManagePosition);

      // On degraded mode, only fetch settings to check server status
      if (isDegradedMode) {
        return of(getSettings(), getProductList());
      }

      // Normal boot - fetch all required data
      return of(
        getSettings(),
        getAssetList(),
        getProductList(),
        getSpotIndices(),
        getGeneralInfoContent(),
        getOptionsInfo(),
        getStats(),
        getOffers()
      );
    })
  );

export const initialAllTickersEpic = (action$, state$) =>
  state$.pipe(
    map(state => state.trade.product_names), // listening on product_names
    filter(isNotEmpty),
    take(1),
    mergeMap(() =>
      of(
        getAllTickers(
          'futures,perpetual_futures,move_options,put_options,call_options,options_combos,spot'
        ),
        connectSocket(),
        connectPublicSocket()
      )
    )
  );
